import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectShowingMenuBar } from '../../../services/store/modules/app-controls';
import ErrorMessage from '../../shared/ErrorMessage/ErrorMessage';
import LogoSpinner from '../../shared/_deprecated/components/LogoSpinner/LogoSpinner';
import styles from './PageHolderContent.scss';

const cx = classNames.bind(styles);

const PageHolderContent = (props) => {
  const {
    headerBarContent,
    footerBarContent,
    addFooterBarPadding,
    errorDescription,
    errorHeading,
    showHeader,
    transparentBackground,
    isLoading,
    children,
    className,
  } = props;

  const showingMenuBar = useSelector(selectShowingMenuBar);

  const viewClasses = cx('page-holder-content', {
    'page-holder-content--transparentBackground': transparentBackground,
    'page-holder-content--is-loading': isLoading,
    'page-holder-content--hide-menubar': !showingMenuBar,
    'page-holder-content--hide-content': isLoading || errorDescription,
    [className]: className,
  });

  const footerBarClasses = cx('page-holder-content__sticky-footer', {
    'page-holder-content__sticky-footer--add-padding': addFooterBarPadding,
    [className]: className,
  });

  return (
    <div className={viewClasses}>
      {headerBarContent && showHeader && (
        <div
          id="pageHolderStickyHeader"
          className={cx('page-holder-content__sticky-header')}
        >
          {headerBarContent}
        </div>
      )}

      {errorDescription && (
        <ErrorMessage
          className={cx('page-holder-content__error-message')}
          heading={errorHeading}
          description={
            (errorDescription && errorDescription.message) || undefined
          }
        />
      )}

      {isLoading && !errorDescription && (
        <LogoSpinner
          className={cx('page-holder-content__logo-spinner')}
          background={false}
        />
      )}

      <div className={cx('page-holder-content__scrolling-body')}>
        {children}
      </div>

      {footerBarContent && !errorDescription && (
        <div className={footerBarClasses}>{footerBarContent}</div>
      )}
    </div>
  );
};

PageHolderContent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({}),
    PropTypes.node,
  ]),
  headerBarContent: PropTypes.node,
  footerBarContent: PropTypes.node,
  transparentBackground: PropTypes.bool,
  addFooterBarPadding: PropTypes.bool,

  errorDescription: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.string,
  ]),

  errorHeading: PropTypes.string,

  showHeader: PropTypes.bool,

  isLoading: PropTypes.bool,
  className: PropTypes.string,
};

PageHolderContent.defaultProps = {
  showHeader: true,
  children: undefined,
  headerBarContent: null,
  footerBarContent: null,
  addFooterBarPadding: false,
  transparentBackground: false,
  errorDescription: null,
  isLoading: false,
  className: null,
  errorHeading: null,
};

export default PageHolderContent;
